<script>
import {mapGetters, mapActions} from 'vuex'
import LockModal from '../modals/LockModal.vue'
export default {
	components: {
		LockModal
	},
	data() {
		return {
			menu: null,
			title: null,
			show: false,
		}
	},
	computed: {
		modal() {
			return this.$route.params.modal
		},
		activities() {
			return this.activitiesByParent(this.menu)
		},
		...mapGetters({
			userName: 'auth/userName',
			userId: 'auth/userId',
			activitiesByParent: 'activities/byParent',
			activityById: 'activities/byId',
			activityCompleted: 'auth/activityCompleted',
			activityViewed: 'auth/activityViewed',
			evaluationByActivity: 'evaluations/evaluationByActivity',
			checkUnlocks: 'auth/checkUnlocks'
		})
	},

	watch: {
		'$route.params': {
			handler(nVal) {
				if(nVal.module) {
					this.menu = Number(nVal.module)
				}
			},

			deep: true,
			immediate: true
		}
	},

	methods: {
		goToMenu(activity) {
			this.closeArce()
			if(!this.activityCompleted(activity.afterOf) && !this.checkUnlocks(activity.activityId)) {
				this.$refs.lockmodal.show()
				return
			}
			const type = activity.type
			if(type === 'module') return this.setModule(activity)
			if(type === 'video') return this.$router.push({name: 'formation-index', params: {modal: 'video', activity: activity.activityId}})
			if(type === 'gamelearning') return this.$router.push({name: 'formation-activity', params: {module: activity.parent || 0,activity: activity.activityId}})
			if(type === 'questions') return this.$router.push({name: 'formation-questions', params: {module: activity.parent || 0,activity: activity.activityId}})
			return this.$router.push(activity.url)
		},
		goToEvaluation(activity) {
			this.closeArce()
			if(!this.activityViewed(activity.activityId)) {
				return
			}
			return this.$router.push({name: 'formation-evaluation', params: {module: activity.parent || 0,activity: activity.activityId}})
		},
		setModule(module) {
			this.closeArce()
			this.title = module.title
			this.menu = module.activityId
		},
		closeArce(name) {
			let $arce = document.querySelectorAll('.simulator__view')
			let $btn = document.getElementById('btnFiles')
			if($btn) {
				$btn.classList.remove('simulador-open')
				$('#filesRespo').removeClass('simulador-open')
				$('#filesRespoPF').removeClass('simulador-open')
				$btn.dataset.show = ''
			}
			this.closeArceView(name)
		},
		closeArceView(name) {
			let $arce = document.querySelectorAll('.simulator__view')
			$arce.forEach(a => {
				if(a.id == name) {
					return
				}
				a.classList.remove('show')
			})
		},
		toggleArce(name) {
			this.closeArceView(name)
			let $btnfile = document.getElementById('btnFiles')
			if($btnfile) {
				if($btnfile.dataset.show == name) {
					$('#btnFiles').removeClass('simulador-open')
					$('#filesRespo').removeClass('simulador-open')
					$('#filesRespoPF').removeClass('simulador-open')
					$('#btnFiles')[0].dataset.show = ''
	
				} else {
					$('#filesRespo').addClass('simulador-open')
					$('#filesRespoPF').addClass('simulador-open')
					$('#btnFiles').addClass('simulador-open')
					$('#btnFiles')[0].dataset.show = name
				}
			}
			document.getElementById(name).classList.toggle('show')
		},
		...mapActions({
			checkCode: 'activities/checkCode'
		})
	},

	async mounted() {
		this.menu = Number(this.$route.params.module) || null
		try {
			// debugger
			// let data = await this.checkCode('desbloqueoAle$2020')
			this.show = true
		} catch (error) {
			this.show = true
		}
	}
}
</script>
<template>
	<div>
		<div class="menu" :class="{'menu--lateral': $route.name !== 'formation-index'}" v-if="show">
			<button @click="menu = null" class="btn-back" v-if="menu">
				<i class="fa fa-bars" aria-hidden="true"></i>
			</button>
			<transition-group class="btns-menu" tag="div" name="zoom-fade" >
				<template v-for="(activity, index) in activities" >
					<!--  -->
					<div 
					:key="`activity-${index}-${activity.activityId}`"
					class="menu__item" 
					:class="
					`menu__item--${index+1} 
					${(!activityCompleted(activity.afterOf) && !checkUnlocks(activity.activityId)) ? 
					'menu__item--lock' : ''}`" >
						<button  
						@click="goToMenu(activity)" 
						>
							<img :src="activity.icon" alt="">
							<span v-if="activityCompleted(activity.activityId)" class="menu__item-check">
								<img src="@/assets/img/check.png" alt="">
							</span>
							<span v-if="!activityCompleted(activity.afterOf) && !checkUnlocks(activity.activityId)" class="menu__item-check">
								<img src="@/assets/img/lock.png" alt="">
							</span>
							<div class="menu__item-help">
								<p>{{activity.title}}</p>
							</div>
						</button>

						<button 
						class="menu__item-sub"
						:class="{'menu__item--lock': !activityViewed(activity.activityId)}"
						v-if="evaluationByActivity(activity.activityId) && activity.type !== 'questions'"
						@click="goToEvaluation(activity)" >
							<img :src="activity.evuationIcon || require('@/assets/img/menus_05.png')" alt="">
							<span v-if="activityCompleted(activity.activityId)" class="menu__item-check">
								<img src="@/assets/img/check.png" alt="">
							</span>
							<span v-if="!activityCompleted(activity.afterOf)" class="menu__item-check">
								<img src="@/assets/img/lock.png" alt="">
							</span>
							<div class="menu__item-help">
								<p>Trivia {{activity.title}}</p>
							</div>
						</button>
					</div>
				</template>
			</transition-group>
			<div class="btns-simulators">
				<button @click="toggleArce('simulatorPFHelp')" v-if="$route.name !== 'formation-index'" class="btn btn-primary btn-arce mb-1 w-100 d-block px-1" style="font-size: 0.7em">GUIA PF</button>
				<button @click="toggleArce('simulatorPF')" v-if="$route.name !== 'formation-index'" class="btn btn-primary btn-arce mb-1 w-100 d-block px-1" style="font-size: 0.7em">SIMULADOR PF</button>
				<button @click="toggleArce('simulatorArceHelp')" v-if="$route.name !== 'formation-index'" class="btn btn-primary btn-arce mb-1 w-100 d-block px-1" style="font-size: 0.7em">GUIA ARCE</button>
				<button @click="toggleArce('simulatorArce')" v-if="$route.name !== 'formation-index'" class="btn btn-primary btn-arce mb-1 w-100 d-block px-1" style="font-size: 0.7em">SIMULADOR ARCE</button>
			</div>
		</div>
		<div v-else  class="menu" :class="{'menu--lateral': $route.name !== 'formation-index'}">
			<div class="lds-ring"><div></div><div></div><div></div><div></div></div>
		</div>
		<LockModal ref="lockmodal"/>
	</div>
</template>
<style lang="scss" scoped>

</style>